import { AfterViewInit, ChangeDetectionStrategy, Component, effect, untracked, viewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { deduplicateEntityFieldsByFieldName, filterEntityFieldsForSettingsTab, IEntityField } from '../../../common/utilities';
import { EntityFieldConfigListWidgetComponent } from '../../../shared/components/entity-field-config-list-widget/entity-field-config-list-widget.component';

@Component({
  selector: 'app-formly-entity-field-config-widget',
  imports: [EntityFieldConfigListWidgetComponent],
  templateUrl: './formly-entity-field-config-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyEntityFieldConfigWidgetComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {

  entityFieldConfigListWidget = viewChild<EntityFieldConfigListWidgetComponent>('entityFieldConfigListWidget');

  constructor() {
    super();
    effect(() => {
      const detail = this.formState?.detailComponent;
      const list = this.entityFieldConfigListWidget();
      if (!detail?.parentActiveFields || !list) {
        return;
      }
      const parentFields: IEntityField[] = detail.parentActiveFields() ?? [];
      untracked(() => {
        this.applyParentFieldsToList(list, detail, parentFields);
      });
    });
  }

  ngAfterViewInit(): void {
    const list = this.entityFieldConfigListWidget();
    const detail = this.formState.detailComponent;
    if (!list || !detail) {
      return;
    }

    const parentFields: IEntityField[] = detail.parentActiveFields?.() ?? [];
    this.applyParentFieldsToList(list, detail, parentFields);

    if (detail.entityConfig) {
      list.fullItem = detail.entityConfig;
    }
    if (detail.variantForConfig?.()) {
      list.variant = detail.variantForConfig;
    }
    if (detail.entityForConfig?.()) {
      list.entityName = detail.entityForConfig;
    }

    list.refresh();
  }

  private applyParentFieldsToList(
    list: EntityFieldConfigListWidgetComponent,
    detail: { parentActiveFields?: () => IEntityField[] },
    parentFields: IEntityField[],
  ): void {
    const prefix = this.props?.entityFieldConfigFieldPrefix as string | undefined;
    const excludePrefixes = this.props?.entityFieldConfigExcludePrefixes as string[] | undefined;
    const scoped = deduplicateEntityFieldsByFieldName(
      filterEntityFieldsForSettingsTab(parentFields, { prefix, excludePrefixes }),
    );

    if (prefix) {
      list.activeFields.set(scoped);
      list.fieldNameDisplayPrefix.set(prefix);
      list.fieldNameDisplayExcludePrefixes.set(null);
    } else if (excludePrefixes?.length) {
      list.activeFields.set(scoped);
      list.fieldNameDisplayPrefix.set(null);
      list.fieldNameDisplayExcludePrefixes.set(excludePrefixes);
    } else {
      list.activeFields.set(scoped);
      list.fieldNameDisplayPrefix.set(null);
      list.fieldNameDisplayExcludePrefixes.set(null);
    }
  }
}
